// store/modules/demo.js
// State for the public, unauthenticated Post Creator demo (/demo/postCreator). Holds only the
// demo session token and the list of networks it covers - never a real page id (see engine's
// demoSession.js, which resolves those server-side from `network` alone).
export default {
    namespaced: true,
    state: {
        active: false,
        sessionToken: null,
        networks: []
    },
    mutations: {
        setActive(state, value) {
            state.active = value
        },
        setSession(state, { token, networks }) {
            state.sessionToken = token
            state.networks = networks || []
        }
    },
    getters: {
        isActive(state) {
            return state.active
        },
        sessionToken(state) {
            return state.sessionToken
        },
        supportsNetwork: (state) => (network) => state.networks.includes(network)
    }
}
